import L from "leaflet";

import { TILE_REFERRER_POLICY } from "components/maps/tileLayerDefaults";

// Fonte única das camadas base do Esri (ArcGIS Online).
//
// É o basemap default da plataforma. O OSM continua disponível como opção no
// seletor do GeoTiffViewer, mas os servidores públicos dele são mantidos por
// voluntários e não têm SLA para carga de produção — ver osmTileLayer.js.
//
// Atenção: estes endpoints usam a ordem {z}/{y}/{x}, invertida em relação ao
// padrão {z}/{x}/{y} do OSM.
export const ESRI_IMAGERY_URL =
  "https://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}";

export const ESRI_IMAGERY_ATTRIBUTION =
  '&copy; <a href="https://www.esri.com/">Esri</a>, Maxar, Earthstar Geographics';

export const ESRI_TOPO_URL =
  "https://server.arcgisonline.com/ArcGIS/rest/services/World_Topo_Map/MapServer/tile/{z}/{y}/{x}";

export const ESRI_TOPO_ATTRIBUTION = '&copy; <a href="https://www.esri.com/">Esri</a>';

// Zoom máximo que estes serviços renderizam em cobertura ampla.
export const ESRI_MAX_NATIVE_ZOOM = 18;

export function createEsriImageryTileLayer(options = {}) {
  return L.tileLayer(ESRI_IMAGERY_URL, {
    attribution: ESRI_IMAGERY_ATTRIBUTION,
    maxNativeZoom: ESRI_MAX_NATIVE_ZOOM,
    referrerPolicy: TILE_REFERRER_POLICY,
    ...options
  });
}
